import { createContext, useState, type ReactNode } from "react";
import { themeConfig } from "src/configs/theme-config";
import {
  SettingsSchema,
  type Settings,
  type SettingsContextValue,
} from "@ui-kit/theme/types";

export type { SettingsContextValue };

const DEFAULT_SETTINGS: Settings = {
  themeColor: "primary",
  contentWidth: themeConfig.contentWidth,
};

const loadSettings = (): Settings => {
  try {
    const savedSettings = localStorage.getItem("settings");
    return savedSettings
      ? SettingsSchema.parse(JSON.parse(savedSettings))
      : DEFAULT_SETTINGS;
  } catch (e) {
    // oxlint-disable-next-line no-console
    console.error(e);
    return DEFAULT_SETTINGS;
  }
};

export const SettingsContext = createContext<SettingsContextValue>({
  saveSettings: () => null,
  settings: DEFAULT_SETTINGS,
});

export const SettingsProvider = ({ children }: { children: ReactNode }) => {
  const [settings, setSettings] = useState<Settings>(() => {
    if (typeof window === "undefined") {
      return DEFAULT_SETTINGS;
    }
    return loadSettings();
  });

  const saveSettings = (updatedSettings: Settings) => {
    setSettings(updatedSettings);
    localStorage.setItem("settings", JSON.stringify(updatedSettings));
  };

  return (
    <SettingsContext.Provider value={{ settings, saveSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const SettingsConsumer = SettingsContext.Consumer;
